import React from 'react'
import {connect} from "react-redux";
import DataAction from "../../stores/api/DataAction";
import Step1 from "./steps/step1";
import Step2 from "./steps/step2";
import Step3 from "./steps/step3";
import Validation from "./validation/validation";

const mapStateToProps = (state, ownProps) => ({
    ...state
});

class Appointment extends React.Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.props.dispatch(DataAction.requestData())
    }

    render() {
        let nav1Class = ''
        let nav2Class = ''
        let nav3Class = ''

        if (this.props.data.currentStep === 1) {
            nav1Class = 'isActive';
        }

        if (this.props.data.currentStep > 1){
            nav1Class = 'nav-btn'
        }

        if (this.props.data.currentStep === 2) {
            nav2Class = 'isActive';
        }

        if (this.props.data.currentStep > 2){
            nav2Class = 'nav-btn'
        }

        if (this.props.data.currentStep === 3) {
            nav3Class = 'isActive';
        }

        return (

            <div className="c-appointment__content">
                {this.props.data.submitChecker.data === false &&
                <nav className="c-appointment__tabs">
                    <a className={nav1Class} onClick={() => this.props.dispatch(DataAction.navStep(1))}>
                        <span>1</span>
                        <span>Datum en tijd</span>
                    </a>
                    <a className={nav2Class} onClick={() => this.props.dispatch(DataAction.navStep(2))}>
                        <span>2</span>
                        <span>Uw wensen</span>
                    </a>
                    <a className={nav3Class} onClick={() => this.props.dispatch(DataAction.navStep(3))}>
                        <span>3</span>
                        <span>Uw gegevens</span>
                    </a>
                </nav>
                }

                {this.props.data.submitChecker.data === false ? (
                    <div>
                        {this.props.data.currentStep === 1 &&
                        <Step1/>
                        }
                        {this.props.data.currentStep === 2 &&
                        <Step2/>
                        }
                        {this.props.data.currentStep === 3 &&
                        <Step3/>
                        }
                    </div>
                ) : (
                    <div>
                        <Validation/>
                    </div>
                )}


            </div>
        )

    }

}

export default connect(mapStateToProps)(Appointment);
